import fetch from '../config/api'

/**
 * 珍品赏析列表(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 */
const zhenpinList = (language = '1') => fetch('/exhibit/zhenpin_list', {
    p: 'wx',
    language
});

/**
 * 文物快览列表(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {class} 文物类别 1造像 2唐卡 3历史文物 4瓷器 5玉器 6法器 7古籍文献 8民俗 9其他
 * param {num} 分页时表示从第几条开始取
 * param {take} 分页时该值表示每页多少条数据
 */
const fastLookList = (language = '1', num = '0', take = '10', classify = '1') => fetch('/exhibit/exhibit_list', {
    p: 'wx',
    language,
    class: classify,
    skip: num * take, //从第几个开始,
    take
});

/**
 * 文物详情(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 */
const treasuresDetail = (language = '1', exhibit_id) => fetch('/exhibit/exhibit_detail', {
    p: 'wx',
    language,
    exhibit_id
});

export default {
    zhenpinList,
    fastLookList,
    treasuresDetail
}